import { Component, OnInit, Output, EventEmitter, Renderer2 } from '@angular/core';
import templateString from './locationChangeOrder.component.html';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { HttpClient } from '@angular/common/http';

@Component({
  standalone: false,
  template: templateString, host: {'forUniqueComponentId': 'dpefnaewofnwaon'}
})
export class LocationChangeOrderComponent implements OnInit {
    @Output() action = new EventEmitter();
    
    public originalLocations: any;
    
    public locations: any;

    constructor(
        private http: HttpClient,
        private bsModalRef: BsModalRef,
        private renderer: Renderer2
    ) { 
        this.renderer.addClass(document.body, 'md-skin');
		this.renderer.addClass(document.body, 'landing-page');
		this.renderer.addClass(document.body, 'fixed-nav');
    }

    ok() {
        this.http.post("locations/update_order", { location_ids: this.locations.map(function(x) { return x.id; }) }).subscribe(() => {
            this.action.emit(true);
            this.bsModalRef.hide();
		});
    }

    cancel() {
        this.bsModalRef.hide();
    };

    drop(event: CdkDragDrop<string[]>) {
        moveItemInArray(this.locations, event.previousIndex, event.currentIndex);
    }

    ngOnInit() {
        this.locations = JSON.parse(JSON.stringify(this.originalLocations));
    }
}
